/* ============================================================
   LogixX theme — runtime animations & interactions
   ============================================================ */

(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ============================================================
  // 1. SCROLL REVEAL — subtle fade + slide on section entry
  // ============================================================
  function initScrollReveal(){
    if (!('IntersectionObserver' in window)) return;
    if (reduce) {
      document.querySelectorAll('.lx-reveal').forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

    // Tag both outer sections AND deeper content blocks so the animation feels comprehensive
    var selectors = [
      'main > .shopify-section',
      'main > section',
      'main > div',
      'footer'
    ];
    var targets = document.querySelectorAll(selectors.join(','));
    targets.forEach(function(el){
      if (el.closest('.lx-promo-banner')) return;
      el.classList.add('lx-reveal');
      io.observe(el);
    });

    // Safety net: if the observer never fires for an on-screen section
    // (throttled tab, IO edge cases), force it visible after 3s so no
    // content can sit at opacity 0 indefinitely.
    setTimeout(function(){
      document.querySelectorAll('.lx-reveal:not(.is-visible)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 3000);
  }

  // ============================================================
  // 2. LETTER-BY-LETTER HEADING REVEAL
  //    Targets specific big headings, splits into spans, staggers
  // ============================================================
  // ============================================================
  // 2. HEADING BLUR-IN (whole heading, smooth)
  // ============================================================

  function initHeadingReveal(){
    // Whole-heading blur-in (no splitting — smoother, no slideshow feel)
    var selectors = [
      '.hero-th-heading',
      '.lx-stats-heading',
      '.lx-faq-heading',
      '.lx-testi-heading',
      '.lx-spot-heading',
      'main h1',
      'main h2'
    ];
    var headings = document.querySelectorAll(selectors.join(','));
    if (!headings.length) return;
    if (reduce) return;

    headings.forEach(function(h){
      var text = (h.textContent || '').trim();
      if (text.length < 2) return;
      if (h.closest('summary')) return; // accordion labels are headings for the outline, not display headings
      h.classList.add('lx-blur-in');
    });

    if (!('IntersectionObserver' in window)) {
      headings.forEach(function(h){ h.classList.add('lx-blur-visible'); });
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('lx-blur-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    headings.forEach(function(h){ io.observe(h); });
  }

  // ============================================================
  // 3. PARALLAX — background shapes drift on scroll
  // ============================================================
  function initParallax(){
    if (reduce) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;

    var rafId = null;
    function update(){
      els.forEach(function(el){
        var rect = el.getBoundingClientRect();
        var winH = window.innerHeight;
        var speed = parseFloat(el.dataset.parallax) || 0.15;
        // How far through viewport (-1 = above, 0 = center, +1 = below)
        var progress = (rect.top + rect.height / 2 - winH / 2) / winH;
        var offset = progress * speed * 100;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
      rafId = null;
    }
    function onScroll(){
      if (rafId === null) rafId = requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  // ============================================================
  // 4. OFF-SCREEN PAUSE — stop perpetual hero/marquee motion when
  //    it scrolls out of view (cheaper, calmer; no always-on GPU work)
  // ============================================================
  function initOffscreenPause(){
    if (reduce) return; // reduced-motion already disables these via CSS
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.hero-swimmers, .marquee, .lx-mq, .hmq, .lx-tq, .lx-faq, .lx-hiw');
    if (!targets.length) return;

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        entry.target.classList.toggle('lx-anim-paused', !entry.isIntersecting);
      });
    }, { rootMargin: '0px' });

    targets.forEach(function(el){ io.observe(el); });
  }

  // ---- Init all ----
  function init(){
    initScrollReveal();
    initHeadingReveal();
    initParallax();
    initOffscreenPause();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   LX ICON SHIM — replaces Phosphor <i class="ph ph-name"> tags
   with inline SVGs from a local map. No CDN, no font, no tofu.
   ============================================================ */
(function () {
  'use strict';
  var F = '#F#'; /* marker: filled icon (logos) */
  var I = {
    'shield-check': '<path d="M12 2.5 20 5.5v6c0 5-3.8 8.6-8 10-4.2-1.4-8-5-8-10v-6z"/><polyline points="8.8 12 11 14.2 15.4 9.6"/>',
    'shield': '<path d="M12 2.5 20 5.5v6c0 5-3.8 8.6-8 10-4.2-1.4-8-5-8-10v-6z"/>',
    'check-circle': '<circle cx="12" cy="12" r="9"/><polyline points="8 12.5 11 15.5 16.5 9.5"/>',
    'seal-check': '<circle cx="12" cy="12" r="9"/><polyline points="8 12.5 11 15.5 16.5 9.5"/>',
    'flask': '<path d="M9.5 3h5"/><path d="M10 3v6.2L4.8 18.4A2 2 0 0 0 6.6 21h10.8a2 2 0 0 0 1.8-2.6L14 9.2V3"/><path d="M7.5 15h9"/>',
    'test-tube': '<path d="m15 3 6 6"/><path d="M18 6 7.5 16.5a3.5 3.5 0 0 1-5-5L13 1"/><path d="m9 11 4 4"/>',
    'leaf': '<path d="M12 22c8-4 9-13 9-19 0 0-7 1-12 6s-6 12 3 13z"/><path d="M3 22c4-2 8-9 9-13"/>',
    'plant': '<path d="M12 21v-8"/><path d="M12 13c0-4-3-7-8-7 0 5 3 7 8 7z"/><path d="M12 10c0-3.5 2.5-6 7-6 0 4.5-2.5 6-7 6z"/>',
    'tree': '<path d="M12 2 6 10h3l-4 6h5v4h4v-4h5l-4-6h3z"/>',
    'truck': '<rect x="1" y="5" width="14" height="11" rx="1.5"/><path d="M15 9h4l3 3.5V16h-7z"/><circle cx="6" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/>',
    'package': '<path d="m21 7.5-9-5-9 5v9l9 5 9-5z"/><path d="m3.3 7.6 8.7 4.9 8.7-4.9"/><path d="M12 22V12.5"/>',
    'cube': '<path d="m21 7.5-9-5-9 5v9l9 5 9-5z"/><path d="m3.3 7.6 8.7 4.9 8.7-4.9"/><path d="M12 22V12.5"/>',
    'magnifying-glass': '<circle cx="11" cy="11" r="7"/><path d="m20.5 20.5-4.6-4.6"/>',
    'image': '<rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.5-3.5a2 2 0 0 0-2.8 0L7 19"/>',
    'calendar': '<rect x="3" y="5" width="18" height="16" rx="2.5"/><path d="M8 3v4M16 3v4M3 10h18"/>',
    'calendar-blank': '<rect x="3" y="5" width="18" height="16" rx="2.5"/><path d="M8 3v4M16 3v4M3 10h18"/>',
    'newspaper': '<path d="M4 5h13a2 2 0 0 1 2 2v11a2 2 0 0 0 2 2H6a2 2 0 0 1-2-2z"/><path d="M19 20a2 2 0 0 0 2-2V9"/><path d="M8 9h5M8 13h5M8 17h5"/>',
    'newspaper-clipping': '<path d="M4 4h16v17l-2.5-1.5L15 21l-3-1.5L9 21l-2.5-1.5L4 21z"/><path d="M8 9h8M8 13h8"/>',
    'article': '<rect x="4" y="4" width="16" height="16" rx="2.5"/><path d="M8 9h8M8 12.5h8M8 16h5"/>',
    'file-text': '<path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z"/><path d="M14 2v5h5"/><path d="M9 13h6M9 17h6"/>',
    'info': '<circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="8" r="0.5" fill="currentColor"/>',
    'user': '<circle cx="12" cy="8.5" r="4"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>',
    'circle': '<circle cx="12" cy="12" r="8.5"/>',
    'circle-half-tilt': '<circle cx="12" cy="12" r="8.5"/><path d="M6 18 18 6a8.5 8.5 0 0 1-12 12z" fill="currentColor" stroke="none"/>',
    'caret-down': '<polyline points="6 9.5 12 15.5 18 9.5"/>',
    'shopping-bag': '<path d="M5 7h14l-1 13a2 2 0 0 1-2 1.8H8A2 2 0 0 1 6 20z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/>',
    'lightning': '<path d="M13 2 4.5 13.5H11L9.5 22 19 10h-6.5z"/>',
    'clock': '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>',
    'clock-countdown': '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/><path d="M12 3V1M19.5 4.5 21 3"/>',
    'x': '<path d="M6 6l12 12M18 6 6 18"/>',
    'plus': '<path d="M12 5v14M5 12h14"/>',
    'minus': '<path d="M5 12h14"/>',
    'warning-circle': '<circle cx="12" cy="12" r="9"/><path d="M12 7.5V13"/><circle cx="12" cy="16.5" r="0.5" fill="currentColor"/>',
    'warning': '<path d="M10.3 3.7 1.8 18.5A2 2 0 0 0 3.5 21.5h17a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0z"/><path d="M12 9v5"/><circle cx="12" cy="17.3" r="0.5" fill="currentColor"/>',
    'vitamin': '<rect x="2.5" y="8.5" width="19" height="7" rx="3.5" transform="rotate(-35 12 12)"/><path d="m8.5 8 7 8" transform="rotate(0 12 12)"/>',
    'pill': '<rect x="2.5" y="8.5" width="19" height="7" rx="3.5" transform="rotate(-35 12 12)"/><path d="m9 9.5 5.5 5.5"/>',
    'trend-up': '<polyline points="3 17 9.5 10.5 13.5 14.5 21 7"/><polyline points="15 7 21 7 21 13"/>',
    'tag': '<path d="M3 3h8l10 10-8 8L3 11z"/><circle cx="8" cy="8" r="1.4"/>',
    'star': '<polygon points="12 2.5 14.9 8.7 21.5 9.4 16.6 14 18 20.7 12 17.3 6 20.7 7.4 14 2.5 9.4 9.1 8.7"/>',
    'sparkle': '<path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/>',
    'receipt': '<path d="M5 3h14v18l-2.3-1.5L14.4 21l-2.4-1.5L9.6 21l-2.3-1.5L5 21z"/><path d="M9 8h6M9 12h6"/>',
    'heartbeat': '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21.2l8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/><path d="M3.5 12H8l2-3 2.5 5L14.5 11h5"/>',
    'heart': '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21.2l8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/>',
    'heart-straight': '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21.2l8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/>',
    'gender-female': '<circle cx="12" cy="9" r="5.5"/><path d="M12 14.5V22M8.5 18.5h7"/>',
    'arrow-up-right': '<path d="M7 17 17 7"/><path d="M9 7h8v8"/>',
    'arrow-right': '<path d="M4 12h16"/><path d="m14 6 6 6-6 6"/>',
    'arrow-left': '<path d="M20 12H4"/><path d="m10 6-6 6 6 6"/>',
    'arrows-left-right': '<path d="M4 8h14l-3-3M20 16H6l3 3"/>',
    'arrow-counter-clockwise': '<path d="M3.5 9A9 9 0 1 1 3 13"/><polyline points="3 4.5 3.5 9 8 8.5"/>',
    'repeat': '<path d="m17 2 4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
    'trash': '<path d="M4 7h16"/><path d="M9 7V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V7"/><path d="M6.5 7l1 13a2 2 0 0 0 2 1.8h5a2 2 0 0 0 2-1.8l1-13"/><path d="M10 11.5v5M14 11.5v5"/>',
    'stethoscope': '<path d="M5 3v6a5 5 0 0 0 10 0V3"/><path d="M5 3H4M15 3h1"/><path d="M10 14v3a5 5 0 0 0 10 0v-2"/><circle cx="20" cy="12.5" r="2"/>',
    'squares-four': '<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/>',
    'phone': '<path d="M22 16.9v2.6a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 3.7 2 2 0 0 1 4.1 1.5h2.6a2 2 0 0 1 2 1.7c.13.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.1L7.8 9.2a16 16 0 0 0 6 6l1.1-1.1a2 2 0 0 1 2.1-.45c.9.34 1.84.57 2.8.7a2 2 0 0 1 1.7 2z"/>',
    'number-circle-one': '<circle cx="12" cy="12" r="9"/><path d="M10.5 9.5 12.5 8v8"/>',
    'number-circle-two': '<circle cx="12" cy="12" r="9"/><path d="M9.8 9.6A2.4 2.4 0 0 1 14.4 10c0 .8-.5 1.5-1.2 2.2L9.8 15.5H14.4"/>',
    'note-pencil': '<path d="M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6"/><path d="M18.4 2.6a2 2 0 0 1 2.8 2.8L13 13.6 9 14.5l.9-4z"/>',
    'lock': '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/><circle cx="12" cy="15.5" r="1.2"/>',
    'lock-simple': '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>',
    'lightbulb': '<path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.7c.7.5 1 1.3 1 2.1V18h6v-1.2c0-.8.3-1.6 1-2.1A7 7 0 0 0 12 2z"/>',
    'headset': '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/><path d="M4 14h2.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1H5a1.5 1.5 0 0 1-1.5-1.5z"/><path d="M20 14h-2.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1H19a1.5 1.5 0 0 0 1.5-1.5V14z"/><path d="M19.5 19.5v.5a2 2 0 0 1-2 2H13"/>',
    'globe-hemisphere-west': '<circle cx="12" cy="12" r="8.8"/><path d="M3.5 12h17M12 3.2c2.6 2.4 4 5.4 4 8.8s-1.4 6.4-4 8.8c-2.6-2.4-4-5.4-4-8.8s1.4-6.4 4-8.8z"/>',
    'flame': '<path d="M12 2s5.5 4.5 5.5 10a5.5 5.5 0 0 1-11 0c0-2 1-4 2.5-5.5 0 0 .5 2.5 2 3.5C11 8 12 5 12 2z"/>',
    'envelope': '<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m4 7 8 6 8-6"/>',
    'envelope-simple': '<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m4 7 8 6 8-6"/>',
    'couch': '<path d="M5 10V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2"/><path d="M3 13a2 2 0 0 1 4 0v1h10v-1a2 2 0 0 1 4 0v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M5 18v2M19 18v2"/>',
    'citrus': '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="5.5"/><path d="M12 6.5v11M7.2 9.2l9.6 5.6M7.2 14.8l9.6-5.6"/>',
    'cherries': '<circle cx="8" cy="17" r="4"/><circle cx="17" cy="15" r="3.4"/><path d="M8 13c0-5 3-8 8-9"/><path d="M17 11.6C17 8 15 5 12 4"/>',
    'chats-circle': '<path d="M8 14a6 6 0 1 1 6-6"/><path d="M9 14a6 6 0 1 0 11.5 2.5L21.5 20l-3.4-1A6 6 0 0 1 9 14z"/>',
    'brain': '<path d="M9.5 3A3.5 3.5 0 0 0 6 6.5c-1.8.4-3 1.9-3 3.8 0 1.1.5 2.1 1.2 2.8C3.5 13.8 3 14.8 3 16a3.5 3.5 0 0 0 6.5 1.8V5A2 2 0 0 1 9.5 3z"/><path d="M14.5 3A3.5 3.5 0 0 1 18 6.5c1.8.4 3 1.9 3 3.8 0 1.1-.5 2.1-1.2 2.8.7.7 1.2 1.7 1.2 2.9a3.5 3.5 0 0 1-6.5 1.8V5a2 2 0 0 0-2-2z"/>',
    'book': '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V4a2 2 0 0 0-2-2H6.5A2.5 2.5 0 0 0 4 4.5v15z"/><path d="M20 22H6.5a2.5 2.5 0 0 1 0-5H20"/>',
    'atom': '<circle cx="12" cy="12" r="1.6" fill="currentColor"/><ellipse cx="12" cy="12" rx="9" ry="3.6"/><ellipse cx="12" cy="12" rx="9" ry="3.6" transform="rotate(60 12 12)"/><ellipse cx="12" cy="12" rx="9" ry="3.6" transform="rotate(120 12 12)"/>',
    'microscope': '<path d="M6 21h12"/><path d="M9.5 18a7 7 0 0 0 7.8-9.5"/><path d="M9 14.5 5.8 11.3a1.6 1.6 0 0 1 0-2.3l4.6-4.6a1.6 1.6 0 0 1 2.3 0l1.9 1.9a1.6 1.6 0 0 1 0 2.3l-4.6 4.6a1.6 1.6 0 0 1-2.3 0z"/><path d="M12.5 18H18"/>',
    'map-pin': '<path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>',
    'linkedin-logo': F + '<path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4V23h-4V8zm7.5 0h3.8v2.05h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V23h-4v-7.9c0-1.88-.03-4.3-2.62-4.3-2.62 0-3.02 2.05-3.02 4.16V23H8V8z"/>',
    'facebook-logo': F + '<path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0 0 22 12z"/>',
    'x-logo': F + '<path d="M17.7 2H21l-7.3 8.3L22.3 22h-6.8l-5.3-6.9L4.1 22H.9l7.8-8.9L1.5 2h7l4.8 6.3zM16.5 20h1.9L6.6 3.9H4.6z"/>',
    /* ---- icons used in sections/templates that were missing from the map ---- */
    'arrows-out-cardinal': '<path d="M12 2v20M2 12h20"/><path d="m9 5 3-3 3 3M9 19l3 3 3-3M5 9 2 12l3 3M19 9l3 3-3 3"/>',
    'barbell': '<path d="M6 8v8M18 8v8M3 10v4M21 10v4"/><path d="M6 12h12"/>',
    'bowl-food': '<path d="M3 11h18a9 9 0 0 1-18 0z"/><path d="M8 11c0-3 2-5 4-5s4 2 4 5"/><path d="M9 21h6"/>',
    'cells': '<circle cx="8" cy="9" r="4.5"/><circle cx="16" cy="15" r="4.5"/><circle cx="8" cy="9" r="1.2" fill="currentColor"/><circle cx="16" cy="15" r="1.2" fill="currentColor"/>',
    'cigarette': '<rect x="2" y="13" width="17" height="5" rx="1"/><path d="M22 13v5"/><path d="M16 9c0-2 2-2 2-4M12 9c0-2 2-2 2-4"/>',
    'cigarette-slash': '<rect x="2" y="13" width="17" height="5" rx="1"/><path d="M22 13v5"/><path d="M4 4l16 16"/>',
    'clipboard-text': '<rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4V3h6v1M9 11h6M9 15h6"/>',
    'diamond': '<path d="M12 2.5 21.5 12 12 21.5 2.5 12z"/>',
    'dna': '<path d="M6 3c0 6 12 6 12 12s-12 6-12 6M18 3c0 6-12 6-12 12s12 6 12 6"/><path d="M7.5 7.5h9M7.5 16.5h9M9 12h6"/>',
    'drop': '<path d="M12 2.5s6.5 7 6.5 12a6.5 6.5 0 0 1-13 0c0-5 6.5-12 6.5-12z"/>',
    'egg': '<path d="M12 2.5c4 0 7 6.5 7 11.5a7 7 0 0 1-14 0c0-5 3-11.5 7-11.5z"/>',
    'first-aid-kit': '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/><path d="M12 11v5M9.5 13.5h5"/>',
    'flag': '<path d="M5 22V3"/><path d="M5 4h12l-2.5 4L17 12H5"/>',
    'globe': '<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c3 3.5 3 14.5 0 18M12 3c-3 3.5-3 14.5 0 18"/>',
    'hash': '<path d="M5 9h14M5 15h14M10 3 8 21M16 3l-2 18"/>',
    'hourglass': '<path d="M6 3h12M6 21h12"/><path d="M7 3v3a5 5 0 0 0 10 0V3M7 21v-3a5 5 0 0 1 10 0v3"/><path d="M7 11.5c1.5 1.3 8.5 1.3 10 0"/>',
    'moon': '<path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/>',
    'pizza': '<path d="M12 21 3 6a18 18 0 0 1 18 0z"/><path d="M5.5 10a13 13 0 0 1 13 0"/><circle cx="12" cy="12.5" r="1" fill="currentColor"/><circle cx="9.5" cy="15.5" r="1" fill="currentColor"/>',
    'question': '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7"/><circle cx="12" cy="17" r="0.5" fill="currentColor"/>',
    'rocket': '<path d="M12 2c3 3 4.5 8 3 13H9c-1.5-5 0-10 3-13z"/><path d="M9 15 6 18l1 3M15 15l3 3-1 3"/><circle cx="12" cy="9" r="1.5"/>',
    'scales': '<path d="M12 3v18M5 21h14"/><path d="M4 7h16"/><path d="M7 7 4 14h6zM17 7l-3 7h6z"/>',
    'shield-warning': '<path d="M12 2.5 20 5.5v6c0 5-3.8 8.6-8 10-4.2-1.4-8-5-8-10v-6z"/><path d="M12 8v4.5"/><circle cx="12" cy="15.5" r="0.5" fill="currentColor"/>',
    'snowflake': '<path d="M12 2v20M2 12h20M5 5l14 14M19 5 5 19"/>',
    'star-half': '<path d="M12 3v15.5l-5.5 3 1-6.2L3 10.9l6.2-.9z"/><path d="M12 3l2.8 7 6.2.9-4.5 4.4 1 6.2L12 18.5" stroke-dasharray="2 2"/>',
    'sun': '<circle cx="12" cy="12" r="4"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"/>',
    'target': '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/>',
    'thermometer': '<path d="M10 4a2 2 0 0 1 4 0v9.5a4 4 0 1 1-4 0z"/><path d="M12 9v6"/>',
    'thermometer-cold': '<path d="M10 4a2 2 0 0 1 4 0v9.5a4 4 0 1 1-4 0z"/><path d="M12 13v2"/><path d="M19 4v6M16.5 5.5l5 3M21.5 5.5l-5 3"/>',
    'thermometer-hot': '<path d="M10 4a2 2 0 0 1 4 0v9.5a4 4 0 1 1-4 0z"/><path d="M12 7v8"/><path d="M19 4c-1.5 1.5-1.5 3 0 4.5s1.5 3 0 4.5"/>',
    'tree-structure': '<rect x="3" y="3" width="6" height="5" rx="1"/><rect x="15" y="3" width="6" height="5" rx="1"/><rect x="9" y="16" width="6" height="5" rx="1"/><path d="M6 8v4h12V8M12 12v4"/>',
    'users': '<circle cx="9" cy="8.5" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><path d="M16 5.5a3.5 3.5 0 0 1 0 6.5"/><path d="M17.5 14a6 6 0 0 1 4 6"/>',
    'virus': '<circle cx="12" cy="12" r="5.5"/><path d="M12 2v4.5M12 17.5V22M2 12h4.5M17.5 12H22M5 5l3.2 3.2M15.8 15.8 19 19M5 19l3.2-3.2M15.8 8.2 19 5"/>',
    'warning-octagon': '<path d="M7.8 2.5h8.4l5.3 5.3v8.4l-5.3 5.3H7.8l-5.3-5.3V7.8z"/><path d="M12 7.5V13"/><circle cx="12" cy="16.5" r="0.5" fill="currentColor"/>',
    'wine': '<path d="M8 3h8l1 6a5 5 0 0 1-10 0z"/><path d="M12 14v7M8 21h8"/>',
  };
  function build(name) {
    var d = I[name] || I['circle'];
    var fill = d.indexOf(F) === 0;
    if (fill) d = d.slice(F.length);
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('width', '1em'); s.setAttribute('height', '1em');
    s.setAttribute('aria-hidden', 'true');
    if (fill) { s.setAttribute('fill', 'currentColor'); }
    else {
      s.setAttribute('fill', 'none');
      s.setAttribute('stroke', 'currentColor');
      s.setAttribute('stroke-width', '1.8');
      s.setAttribute('stroke-linecap', 'round');
      s.setAttribute('stroke-linejoin', 'round');
    }
    s.innerHTML = d;
    return s;
  }
  function run() {
    /* weight classes (ph-fill, ph-bold…) are not icon names; filled icons get a solid fill */
    document.querySelectorAll('i.ph, i.ph-fill, i.ph-bold, i.ph-light, i.ph-thin, i.ph-duotone').forEach(function (n) {
      if (n.dataset.lxIco) return;
      n.dataset.lxIco = '1';
      var m = n.className.match(/(?:^|\s)ph-(?!fill\b|bold\b|light\b|thin\b|duotone\b|regular\b)([a-z0-9-]+)/);
      n.textContent = '';
      var svg = build(m ? m[1] : 'circle');
      if (/(?:^|\s)ph-fill(?:\s|$)/.test(n.className)) { svg.setAttribute('fill', 'currentColor'); svg.setAttribute('stroke-width', '1'); }
      n.appendChild(svg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* catch late-rendered icons (sliders, drawers, AJAX cart) */
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { run(); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============================================================
   AJAX ADD TO CART — shop cards add to the basket inline,
   no redirect to /cart. Progressive: forms still POST without JS.
   ============================================================ */
(function(){
  if (!window.fetch) return;

  function setBadge(count, cart){
    /* Current header (sections/header.liquid) renders .lxth-cart with a
       .lxth-cart-count badge. The count span only exists when the cart was
       non-empty at page load, so create it when the first item is added. */
    var cartLink = document.querySelector('.lxth-cart');
    if (cartLink){
      var host = cartLink.querySelector('.lxth-btn') || cartLink;
      var cnt = cartLink.querySelector('.lxth-cart-count');
      if (count > 0){
        if (!cnt){ cnt = document.createElement('span'); cnt.className = 'lxth-cart-count'; host.appendChild(cnt); }
        cnt.textContent = count;
      } else if (cnt && cnt.parentNode){
        cnt.parentNode.removeChild(cnt);
      }
      cartLink.setAttribute('aria-label', count > 0 ? 'Cart (' + count + (count === 1 ? ' item)' : ' items)') : 'Cart');
      /* Only refresh the total when the merchant has it switched on — the
         markup is rendered conditionally, so never create it here. */
      var tot = cartLink.querySelector('.lxth-cart-total');
      if (tot && cart && typeof cart.total_price === 'number'){
        try {
          tot.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency', currency: cart.currency || 'GBP'
          }).format(cart.total_price / 100);
        } catch (e){ /* leave the server-rendered total alone */ }
      }
    }

    /* Legacy header markup, kept so older sections keep working. */
    var btn = document.querySelector('.cart-icon-btn');
    if (!btn) return;
    var badge = btn.querySelector('.cart-badge');
    if (count > 0){
      if (!badge){ badge = document.createElement('span'); badge.className = 'cart-badge'; btn.appendChild(badge); }
      badge.textContent = count;
      badge.classList.remove('cart-badge--pop');
      void badge.offsetWidth; /* restart animation */
      badge.classList.add('cart-badge--pop');
    } else if (badge && badge.parentNode){
      badge.parentNode.removeChild(badge);
    }
  }

  function flash(btn, msg, cls){
    if (!btn) return;
    if (btn.getAttribute('data-lx-label') === null) btn.setAttribute('data-lx-label', btn.innerHTML);
    btn.classList.add(cls);
    btn.innerHTML = msg;
    clearTimeout(btn._lxT);
    btn._lxT = setTimeout(function(){
      btn.innerHTML = btn.getAttribute('data-lx-label');
      btn.classList.remove(cls);
    }, 1800);
  }

  function showMsg(form, text){
    var box = (form.closest && form.closest('.lxshop-card-body, .lxshop-feat-body')) || form.parentNode;
    if (!box) return;
    var m = box.querySelector('.lxshop-atc-msg');
    if (!m){ m = document.createElement('div'); m.className = 'lxshop-atc-msg'; box.appendChild(m); }
    m.textContent = text;
    clearTimeout(m._t); m._t = setTimeout(function(){ if (m.parentNode) m.parentNode.removeChild(m); }, 7000);
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('lxshop-atc')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn && btn.disabled) return;
    var idEl = form.querySelector('[name="id"]');
    var vid = idEl ? String(idEl.value || '').trim() : '';
    if (!vid){ showMsg(form, 'This product has no variant to add.'); return; }
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
    .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
    .then(function(res){
      if (!res.ok){ throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.'); }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
    })
    .then(function(cart){ setBadge(cart.item_count, cart); flash(btn, 'Added ✓', 'is-added'); })
    .catch(function(err){
      if (window.console && console.warn) console.warn('[LogixX add to cart]', err && err.message);
      flash(btn, 'Try again', 'is-error');
      showMsg(form, (err && err.message) ? err.message : 'Could not add to cart.');
    })
    .then(function(){ if (btn) btn.disabled = false; });
  });
})();

/* ============================================================
   === HOMEPAGE 2026 (lxh-) ===
   Runtime for the new homepage sections: reveal-on-scroll,
   watermark letter stagger, count-up stats, filmstrip/marquee
   off-screen pause, range selector, stories carousel, FAQ.
   All idempotent (data-lxh-init guards) so the Shopify theme
   editor can re-run init() on section load.
   ============================================================ */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- watermark: split into staggered letter spans ---- */
  function initLetters(scope){
    scope.querySelectorAll('[data-lxh-letters]').forEach(function(el){
      if (el.dataset.lxhInit) return;
      el.dataset.lxhInit = '1';
      if (reduce) return;
      var text = el.textContent;
      el.textContent = '';
      for (var i = 0; i < text.length; i++){
        if (text[i] === ' '){ el.appendChild(document.createTextNode(' ')); continue; }
        var s = document.createElement('span');
        s.className = 'lxh-wm-l';
        s.style.setProperty('--wd', (0.05 + i * 0.07).toFixed(2) + 's');
        s.textContent = text[i];
        el.appendChild(s);
      }
    });
  }

  /* ---- count-up numbers ---- */
  function runCounts(section){
    section.querySelectorAll('[data-lxh-count]').forEach(function(el){
      if (el.dataset.lxhCounted) return;
      el.dataset.lxhCounted = '1';
      var target = parseFloat(el.getAttribute('data-lxh-count'));
      if (isNaN(target)) return;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var min = parseFloat(el.getAttribute('data-min')) || 0;
      function fmt(n){
        n = Math.max(min, Math.round(n));
        return prefix + (target >= 1000 ? n.toLocaleString('en-GB') : String(n)) + suffix;
      }
      if (reduce){ el.textContent = fmt(target); return; }
      var dur = 1400, t0 = null;
      function tick(t){
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = fmt(target * e);
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* ---- reveal-on-scroll for [data-lxh-reveal] ---- */
  function initReveal(scope){
    var sections = scope.querySelectorAll('[data-lxh-reveal]');
    if (!sections.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      sections.forEach(function(s){ s.classList.add('lxh-in'); runCounts(s); });
      return;
    }
    /* Gate the hiding CSS on this class so no-JS visitors see content */
    document.documentElement.classList.add('lxh-js');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lxh-in');
        runCounts(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
    sections.forEach(function(s){
      if (s.dataset.lxhRevealInit) return;
      s.dataset.lxhRevealInit = '1';
      io.observe(s);
    });
    /* safety net: never leave on-screen content hidden */
    setTimeout(function(){
      sections.forEach(function(s){
        if (s.classList.contains('lxh-in')) return;
        var r = s.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0){ s.classList.add('lxh-in'); runCounts(s); }
      });
    }, 3000);
  }

  /* ---- pause marquees while off-screen ---- */
  function initMarqueePause(scope){
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = scope.querySelectorAll('[data-lxh-marquee-scope]');
    if (!els.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        entry.target.classList.toggle('lxh-paused', !entry.isIntersecting);
      });
    }, { rootMargin: '0px' });
    els.forEach(function(el){
      if (el.dataset.lxhMqInit) return;
      el.dataset.lxhMqInit = '1';
      io.observe(el);
    });
  }

  /* ---- range selector: expanding product panels ---- */
  function initRange(scope){
    scope.querySelectorAll('[data-lxh-range]').forEach(function(range){
      if (range.dataset.lxhInit) return;
      range.dataset.lxhInit = '1';
      var items = Array.prototype.slice.call(range.querySelectorAll('[data-lxh-range-item]'));
      function open(target){
        items.forEach(function(item){
          var on = item === target;
          item.classList.toggle('is-open', on);
          item.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        /* On phones the accordion re-flows the page; follow the
           opened panel so the user isn't left mid-page. */
        if (window.matchMedia && window.matchMedia('(max-width: 759px)').matches){
          setTimeout(function(){
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          }, 60);
        }
      }
      items.forEach(function(item){
        item.addEventListener('click', function(e){
          if (item.classList.contains('is-open')) return;
          if (e.target.closest('a')) return;
          open(item);
        });
        item.addEventListener('keydown', function(e){
          if (e.key !== 'Enter' && e.key !== ' ') return;
          if (e.target !== item) return;
          e.preventDefault();
          open(item);
        });
      });
    });
  }

  /* ---- stories carousel ---- */
  function initStories(scope){
    scope.querySelectorAll('[data-lxh-stories]').forEach(function(root){
      if (root.dataset.lxhInit) return;
      root.dataset.lxhInit = '1';
      var dataEl = root.querySelector('[data-lxh-story-data]');
      var quoteEl = root.querySelector('[data-lxh-story-quote]');
      var nameEl = root.querySelector('[data-lxh-story-name]');
      var locEl = root.querySelector('[data-lxh-story-loc]');
      var counterEl = root.querySelector('[data-lxh-story-counter]');
      var stories;
      try { stories = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!stories || stories.length < 2){
        root.querySelectorAll('.lxh-bento-arrow').forEach(function(b){ b.style.display = 'none'; });
        return;
      }
      var idx = 0, timer = null;
      function pad(n){ return (n < 10 ? '0' : '') + n; }
      function show(i){
        idx = (i + stories.length) % stories.length;
        function swap(){
          quoteEl.textContent = stories[idx].q;
          nameEl.textContent = stories[idx].n;
          locEl.textContent = stories[idx].l;
          if (counterEl) counterEl.textContent = pad(idx + 1) + ' / ' + pad(stories.length);
          root.classList.remove('is-switching');
        }
        if (reduce){ swap(); return; }
        root.classList.add('is-switching');
        clearTimeout(timer);
        timer = setTimeout(swap, 300);
      }
      var prev = root.querySelector('[data-lxh-story-prev]');
      var next = root.querySelector('[data-lxh-story-next]');
      if (prev) prev.addEventListener('click', function(){ show(idx - 1); });
      if (next) next.addEventListener('click', function(){ show(idx + 1); });
    });
  }

  /* ---- FAQ accordion (single open) ---- */
  function initFaq(scope){
    scope.querySelectorAll('[data-lxh-faq]').forEach(function(list){
      if (list.dataset.lxhInit) return;
      list.dataset.lxhInit = '1';
      var items = Array.prototype.slice.call(list.querySelectorAll('.lxh-faq-item'));
      items.forEach(function(item){
        var btn = item.querySelector('[data-lxh-faq-toggle]');
        var body = item.querySelector('.lxh-faq-a');
        if (!btn || !body) return;
        btn.addEventListener('click', function(){
          var isOpen = item.classList.contains('is-open');
          items.forEach(function(other){
            other.classList.remove('is-open');
            var b = other.querySelector('[data-lxh-faq-toggle]');
            var a = other.querySelector('.lxh-faq-a');
            if (b) b.setAttribute('aria-expanded', 'false');
            if (a) a.hidden = true;
          });
          if (!isOpen){
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            body.hidden = false;
          }
        });
      });
    });
  }

  function init(scope){
    scope = scope || document;
    initLetters(scope);
    initReveal(scope);
    initMarqueePause(scope);
    initRange(scope);
    initStories(scope);
    initFaq(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();

  /* theme editor: re-init sections as they are (re)rendered */
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });

  /* theme editor: reveal a selected section instantly, and open the panel
     that belongs to a selected block so merchant edits are visible */
  document.addEventListener('shopify:section:select', function(e){
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-lxh-reveal]:not(.lxh-in)').forEach(function(s){
      s.classList.add('lxh-in');
      runCounts(s);
    });
  });
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target;
    if (!el || !el.closest) return;
    var rangeItem = el.closest('[data-lxh-range-item]');
    if (rangeItem && !rangeItem.classList.contains('is-open')){ rangeItem.click(); return; }
    var faqItem = el.closest('.lxh-faq-item');
    if (faqItem && !faqItem.classList.contains('is-open')){
      var btn = faqItem.querySelector('[data-lxh-faq-toggle]');
      if (btn) btn.click();
    }
  });
})();

/* ============================================================
   === PROXEED PROTOCOL PAGE (lxp-) ===
   Generic rotator (hero tips, voices reviews) and accordion
   (ingredient benefits, questions). Idempotent; re-runs on
   shopify:section:load like the homepage runtime.
   ============================================================ */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* rotator: [data-lxp-rotate="ms"] with [data-lxp-slide] + [data-lxp-dash] */
  function initRotators(scope){
    scope.querySelectorAll('[data-lxp-rotate]').forEach(function(root){
      if (root.dataset.lxpInit) return;
      root.dataset.lxpInit = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lxp-slide]'));
      var dashes = Array.prototype.slice.call(root.querySelectorAll('[data-lxp-dash]'));
      if (slides.length < 2) return;
      var idx = 0, timer = null;
      var delay = parseInt(root.getAttribute('data-lxp-rotate'), 10) || 5000;
      function show(i){
        idx = (i + slides.length) % slides.length;
        slides.forEach(function(s, k){
          if (k === idx){
            if (s.hidden){
              s.hidden = false;
              if (!reduce){
                s.classList.add('lxp-fadestart');
                requestAnimationFrame(function(){
                  requestAnimationFrame(function(){ s.classList.remove('lxp-fadestart'); });
                });
              }
            }
          } else {
            s.hidden = true;
            s.classList.remove('lxp-fadestart');
          }
        });
        dashes.forEach(function(d, k){ d.classList.toggle('is-on', k === idx); });
      }
      function arm(){
        if (reduce) return;
        clearInterval(timer);
        timer = setInterval(function(){ show(idx + 1); }, delay);
      }
      dashes.forEach(function(d, k){
        d.addEventListener('click', function(){ show(k); arm(); });
      });
      root.addEventListener('mouseenter', function(){ clearInterval(timer); });
      root.addEventListener('mouseleave', arm);
      /* hooks for the theme editor: jump to a slide / resume rotation */
      root._lxpShow = function(el){ var i = slides.indexOf(el); if (i >= 0){ show(i); clearInterval(timer); } };
      root._lxpArm = arm;
      arm();
    });
  }

  /* accordion: [data-lxp-acc] with .lxp-acc-item > [data-lxp-acc-toggle] + .lxp-acc-body */
  function initAccordions(scope){
    scope.querySelectorAll('[data-lxp-acc]').forEach(function(list){
      if (list.dataset.lxpInit) return;
      list.dataset.lxpInit = '1';
      var single = list.getAttribute('data-single') === '1';
      var items = Array.prototype.slice.call(list.querySelectorAll('.lxp-acc-item'));
      items.forEach(function(item){
        var btn = item.querySelector('[data-lxp-acc-toggle]');
        var body = item.querySelector('.lxp-acc-body');
        if (!btn || !body) return;
        btn.addEventListener('click', function(){
          var wasOpen = item.classList.contains('is-open');
          if (single){
            items.forEach(function(other){
              other.classList.remove('is-open');
              var b = other.querySelector('[data-lxp-acc-toggle]');
              var a = other.querySelector('.lxp-acc-body');
              if (b) b.setAttribute('aria-expanded', 'false');
              if (a) a.hidden = true;
            });
          }
          if (!wasOpen){
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            body.hidden = false;
          } else if (!single){
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            body.hidden = true;
          }
        });
      });
    });
  }

  /* claim chips: one active at a time — clicked chip takes the accent colour */
  function initCardPick(scope){
    scope.querySelectorAll('.lxp-claims').forEach(function(sec){
      if (sec.dataset.lxpPickInit) return;
      sec.dataset.lxpPickInit = '1';
      var chips = Array.prototype.slice.call(sec.querySelectorAll('[data-lxp-cardpick]'));
      chips.forEach(function(chip){
        chip.addEventListener('click', function(){
          chips.forEach(function(c){
            c.classList.toggle('is-on', c === chip);
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
        });
      });
    });
  }

  function init(scope){
    scope = scope || document;
    initRotators(scope);
    initAccordions(scope);
    initCardPick(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });

  /* Theme editor: when a merchant selects a block whose content lives in a
     hidden slide or closed accordion, bring it into view so their edits are
     visible immediately. */
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target;
    if (!el || !el.closest) return;
    var slide = el.closest('[data-lxp-slide]');
    if (slide){
      var root = slide.closest('[data-lxp-rotate]');
      if (root && root._lxpShow) root._lxpShow(slide);
      return;
    }
    var item = el.closest('.lxp-acc-item');
    if (item && !item.classList.contains('is-open')){
      var btn = item.querySelector('[data-lxp-acc-toggle]');
      if (btn) btn.click();
    }
  });
  document.addEventListener('shopify:block:deselect', function(e){
    var el = e.target;
    var root = el && el.closest ? el.closest('[data-lxp-rotate]') : null;
    if (root && root._lxpArm) root._lxpArm();
  });
})();

/* ============================================================
   HOMEPAGE 2 — shared reveal + count-up.
   Hiding styles are gated on html.hm2-js so no-JS renders visible.
   ============================================================ */
(function(){
  var els = document.querySelectorAll('[data-hm2-reveal], [data-hm2-count]');
  if (!els.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reduce) return;
  document.documentElement.classList.add('hm2-js');

  function countUp(el){
    if (el.dataset.hm2Done) return;
    el.dataset.hm2Done = '1';
    var raw = el.dataset.hm2Count || el.textContent;
    var digits = raw.replace(/[^0-9]/g, '');
    if (!digits) return;
    var target = parseInt(digits, 10);
    var suffix = raw.replace(/^[0-9,.\s]+/, '');
    var t0 = null, DUR = 1400;
    function fmt(n){ return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function tick(ts){
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased)) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function run(){
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        var c = e.target.querySelector ? e.target.querySelectorAll('[data-hm2-count]') : [];
        for (var i = 0; i < c.length; i++) countUp(c[i]);
        if (e.target.hasAttribute('data-hm2-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.18 });
    els.forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.bottom < 0) { el.style.transition = 'none'; el.classList.add('in'); return; }
      io.observe(el);
    });
    // Safety net: force-reveal only what is currently in the viewport
    setTimeout(function(){ els.forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
    }); }, 2600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* HOMEPAGE 2 — pause marquee animations while off-screen (battery/jank) */
(function(){
  var tracks = document.querySelectorAll('.hm2-film-track, .hm2-trusted-track');
  if (!tracks.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(ents){
    ents.forEach(function(e){
      var t = e.target;
      /* Don't fight the hover pause — only toggle when leaving/entering view */
      t.style.animationPlayState = e.isIntersecting ? '' : 'paused';
    });
  }, { threshold: 0 });
  tracks.forEach(function(t){ io.observe(t); });
})();
